import { Component, ViewChild } from '@angular/core';
import { NavController, NavParams, LoadingController, ModalController } from 'ionic-angular';
import { Globals } from "../../../globals";
import { TakeawayServices } from '../../takeaway/services';
import { TranslateService } from '@ngx-translate/core';
import * as firebase from 'firebase';
import { AddonsTriggerVersionProPage } from '../../addons/addons-trigger-version-pro/addons-trigger-version-pro';
import { ColumnMode, DatatableComponent } from '@swimlane/ngx-datatable';
import { CompCreateDeliveryPage } from '../../components/popups/create-delivery/create-delivery';
import { ConfigurationServices } from '../services';

/**
 * Generated class for the ConfigurationRoomsPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
    selector: 'page-configuration-deliveries',
    templateUrl: 'configuration-deliveries.html',
})
export class ConfigurationDeliveriesPage {

    public firestore: any;
    deliveries: any;
    deliveries_filter: any = [];
    search_txt: string = '';
    //datatable
    sorts = [
        { prop: 'name', dir: 'asc' }
    ];
    @ViewChild(DatatableComponent) table: DatatableComponent;
    ColumnMode = ColumnMode;
    config_msg = {
        emptyMessage: this.translate.instant('general-no-hay-datos'),
        totalMessage: this.translate.instant('general-total'),
        selectedMessage: this.translate.instant('general-seleccionado')
    };

    constructor(public navCtrl: NavController,
        public navParams: NavParams,
        public takeawayServices: TakeawayServices,
        public globals: Globals,
        public loadingCtrl: LoadingController,
        public translate: TranslateService,
        public modalCtrl: ModalController,
        public configurationServices: ConfigurationServices) {
        this.firestore = firebase.firestore();


        this.getDeliveries();
    }

    async getDeliveries() {
        let loadingPopup = this.loadingCtrl.create({
            spinner: 'crescent',
            content: this.translate.instant('configuracion-cargando-deliveries')
        });
        loadingPopup.present();
        await this.takeawayServices.getDeliveries();
        await this.configurationServices.recoveryDeliveriesFavorites();
        await this.takeawayServices.getDeliveriesFavorites();
        this.deliveries_filter = [...this.takeawayServices.deliveries];



        loadingPopup.dismiss();
    }

    createDelivery() {
        if (this.globals.checkLimitsByLicense('tpv', 'deliveries')) {
            let profileModal = this.modalCtrl.create(CompCreateDeliveryPage, {
                update_state: false
            });
            profileModal.onDidDismiss(data => {
                if (data) {
                    this.firestore.collection('restaurants/' + this.globals.restaurant_uid + '/deliveries').add({
                        name: data.name
                    }).then(doc => data.UID = doc.id);
                    if (data.active) {
                        this.addDeliveriesFavorites(data);
                    }
                    this.globals.launchToast(this.translate.instant('general-guardado-correctamente'), 3000, 'bottom');
                    this.takeawayServices.deliveries.push(data);
                    this.takeawayServices.deliveries = [...this.takeawayServices.deliveries];
                }
            });
            profileModal.present();
        } else {
            this.navCtrl.push(AddonsTriggerVersionProPage);
        }
    }

    editDelivery(delivery) {
        if (this.globals.checkLimitsByLicense('tpv', 'deliveries')) {
            let profileModal = this.modalCtrl.create(CompCreateDeliveryPage, {
                update_state: true,
                delivery: delivery
            });
            profileModal.onDidDismiss(data => {
                if (data && data.UID && !data.delete) {
                    this.firestore.collection('restaurants/' + this.globals.restaurant_uid + '/deliveries').doc(data.UID).update({
                        'name': data.name
                    });
                    this.globals.launchToast(this.translate.instant('general-guardado-correctamente'), 3000, 'bottom');
                } else if (data && data.delete) {
                    if (data.favorites_UID) {
                        this.deleteDeliveriesFavorites(data);
                    }
                    this.firestore.collection('restaurants/' + this.globals.restaurant_uid + '/deliveries').doc(data.UID).delete();
                    this.globals.launchToast(this.translate.instant('general-eliminado-correctamente'), 3000, 'bottom');
                    this.takeawayServices.deliveries.splice(this.takeawayServices.deliveries.findIndex(item => item.UID == data.UID), 1);
                    this.takeawayServices.deliveries = [...this.takeawayServices.deliveries];
                }
            });
            profileModal.present();
        } else {
            this.navCtrl.push(AddonsTriggerVersionProPage);
        }
    }

    clickElement(event) {
        if (event.type === 'click') {
            if (event.column.name === 'fav') {
                if (event.row.active) {
                    this.deleteDeliveriesFavorites(event.row);
                } else {
                    this.addDeliveriesFavorites(event.row);
                }
                event.row.active = !event.row.active;
            } else {
                if (event.row.UID) {
                    this.editDelivery(event.row);
                }
            }
        }
    }

    addDeliveriesFavorites(delivery) {
        this.firestore.collection('restaurants/' + this.globals.restaurant_uid + '/deliveries_favorites').add({
            'name': delivery.name,
        }).then(doc => {
            delivery.favorites_UID = doc.id;
        });
    }

    deleteDeliveriesFavorites(delivery) {
        this.firestore.collection('restaurants/' + this.globals.restaurant_uid + '/deliveries_favorites').doc(delivery.favorites_UID).delete();
        delivery.favorites_UID = undefined;
    }

    search(value) {
        if (value) {
            this.deliveries_filter = this.takeawayServices.deliveries.filter(x => x.name.toLowerCase().includes(value.toLowerCase()));
        } else {
            this.deliveries_filter = this.takeawayServices.deliveries;
        }
    }
}


// WEBPACK FOOTER //
// ./src/pages/configuration/configuration-deliveries/configuration-deliveries.ts